import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

export class BlockSignoffDaysInAdvanceError extends ExpectedError {
  static override _class = 'BlockSignoffDaysInAdvanceError';

  public constructor() {
    super('BlockSignoffDaysInAdvanceError', { translationKey: 'BLOCK_SIGNOFF_ERROR' });
  }
}
